export const GROUP_OVERVIEW_FEATURE_FLAG = 'group-overview';

export const NEW_PORTAL_FEATURE_FLAG = 'new-portal';

export const COMPANIES_ROUTE = '/companies';

export const GROUP_ROUTE = '/group';

export const GROUP_CLIENTS_ROUTE = '/group/clients';
export const GROUP_COMPANIES_ROUTE = '/group/companies';
export const GROUP_MEMBERS_ROUTE = '/group/members';

export const STEP_TO_STEP_THEME = {
  0: { color: 'var(--mantine-color-blue-4)', filledDots: 1 },
  1: { color: 'var(--mantine-color-warning-3)', filledDots: 2 },
  2: { color: 'var(--mantine-color-warning-5)', filledDots: 3 },
  3: { color: 'var(--mantine-color-coral-5)', filledDots: 4 },
  4: { color: 'var(--mantine-color-error-6)', filledDots: 5 },
  5: { color: 'var(--mantine-color-black)', filledDots: 0 },
};
